import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const problems = [
  {
    icon: 'ri-error-warning-line',
    title: 'Ruptura',
    description:
      'Venda perdida no balcão e cliente atendido pelo concorrente — às vezes para sempre.',
  },
  {
    icon: 'ri-lock-line',
    title: 'Excesso',
    description:
      'Capital parado em produto de baixo giro, ocupando espaço e consumindo caixa.',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'Decisão por intuição',
    description:
      'Compra definida por planilha, memória e pressa — sem base no que realmente vende.',
  },
  {
    icon: 'ri-history-line',
    title: 'ERP sem previsão',
    description:
      'O sistema registra o passado com precisão, mas não projeta o que vai acontecer.',
  },
];

export default function ProblemSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="o-problema" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6" ref={ref}>
        <div className="text-center mb-14">
          <span className="inline-block font-sora font-semibold text-emerald-600 text-sm uppercase tracking-widest mb-3">
            O problema
          </span>
          <h2 className="font-sora font-bold text-3xl md:text-4xl text-zinc-900 mb-4">
            O estoque errado tem um custo silencioso
          </h2>
          <p className="font-inter text-zinc-500 max-w-xl mx-auto text-base">
            Quatro formas comuns de a decisão de compra sair cara para empresas de
            varejo, distribuição e pequena indústria.
          </p>
          <div className="w-12 h-1 bg-emerald-500 rounded-full mx-auto mt-5" />
        </div>

        <ul
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {problems.map((problem) => (
            <li
              key={problem.title}
              className="bg-white rounded-2xl border border-zinc-100 p-6 md:p-8"
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20 mb-4"
                aria-hidden="true"
              >
                <i className={`${problem.icon} text-emerald-600 text-xl`} />
              </div>
              <h3 className="font-sora font-semibold text-lg text-zinc-900 mb-2">
                {problem.title}
              </h3>
              <p className="font-inter text-zinc-500 text-sm leading-relaxed">
                {problem.description}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
